<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { fetchImpuestoPlantillas, saveImpuestoPlantilla, removeImpuestoPlantilla, searchImpuestoPlantillas, subscribeToImpuestoPlantillas, unsubscribeFromImpuestoPlantillas } from '../controllers/impuestoPlantillaController.js';

    let impuestoPlantillaColumns = [
        { label: 'Descripción', field: 'descrip', type: 'text' },
        { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    let newImpuestoPlantilla = {
        descrip: '',
        sta: true,
    };

    let editColumns = [
        { label: 'Descripción', key: 'descrip', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox' },
    ];
</script>

<CRUD 
    title="Plantilla de impuestos"
    entityName="impuesto_plantilla"
    newEntity={newImpuestoPlantilla}
    columns={impuestoPlantillaColumns}
    fetchEntities={fetchImpuestoPlantillas}
    saveEntity={saveImpuestoPlantilla}
    removeEntity={removeImpuestoPlantilla}
    searchEntities={searchImpuestoPlantillas}
    subscribeToChanges={subscribeToImpuestoPlantillas}
    unsubscribeFromChanges={unsubscribeFromImpuestoPlantillas}
    editColumns={editColumns}
/>